import { FilteredTicketType } from "@/types/AdminPanelType";
import { CartTicket } from "@/types/CartType";

type CartTicketSectiontype = {
  [key: string]: CartTicket[]
}

export function groupCartTicketsBySection(cartTickets: CartTicket[], ticketSections: FilteredTicketType[]) {

  const output : CartTicketSectiontype = {}

  ticketSections.forEach((section: FilteredTicketType) => {
    output[section.name] = [];

    if (cartTickets && cartTickets.length > 0) {
      cartTickets.forEach((ticket) => {
        if (section.ids.includes(parseInt(ticket.product_id))) {
          output[section.name].push(ticket);
        }
      });
    }
  });

  return output;
}